import { render, staticRenderFns } from "./call-block-list.vue?vue&type=template&id=d857f60e&scoped=true"
import script from "./call-block-list.vue?vue&type=script&lang=ts"
export * from "./call-block-list.vue?vue&type=script&lang=ts"
import style0 from "./call-block-list.vue?vue&type=style&index=0&id=d857f60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d857f60e",
  null
  
)

export default component.exports